import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../lib/cn.js";
/**
 * docs/design.md §7.5. Cards are load-bearing containers for a single
 * region of information — never nest a `Card` inside another `Card`'s
 * body; use `CardHeader`/`CardBody`/`CardFooter` sections or a plain
 * `<div>` for internal grouping instead (§1.1, "nothing exists on screen
 * for balance").
 */
export function Card({ className, ...props }) {
    return (_jsx("div", { className: cn("rounded-md border border-line-subtle bg-surface-raised", className), ...props }));
}
export function CardHeader({ className, ...props }) {
    return (_jsx("div", { className: cn("flex items-center justify-between gap-3 border-b border-line-subtle px-4 py-3", className), ...props }));
}
export function CardTitle({ className, ...props }) {
    return _jsx("h3", { className: cn("text-h3 text-fg-primary", className), ...props });
}
export function CardBody({ className, ...props }) {
    return _jsx("div", { className: cn("p-4", className), ...props });
}
export function CardFooter({ className, ...props }) {
    return (_jsx("div", { className: cn("flex items-center gap-2 border-t border-line-subtle px-4 py-3", className), ...props }));
}
//# sourceMappingURL=card.js.map